export function Card({ className = '', children, ...props }) {
  const base =
    'bg-white dark:bg-slate-950 rounded-3xl border-2 border-slate-50 dark:border-slate-800 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.08)]'
  return (
    <div {...props} className={`${base} ${className}`.trim()}>
      {children}
    </div>
  )
}
